// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    AUTH: {
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Reset your password?',
        DESC: 'Enter your email to reset your password.',
        SUCCESS_MESSAGE:
          'Please click the link sent to your email to verify your account.Thank you',
        CHECK_EMAIL: 'Check Your Email',
        BACK_TO_HOME: 'Back To Login Screen',
        MISS: 'Didn’t receive an email?',
        RESEND: 'Resend',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        MIN: 'Minimum Is:',
        MAX: 'Maximum Is:',
      },
    },
    BUTTONS: {
      EDIT: 'Edit',
      ADD: 'Add',
      DELETE: 'Delete',
      SAVE: 'Save',
      CANCEL: 'Cancel',
      REPORT: 'Report',
      SUBMIT: 'Submit',
      CHANGE_STATUS: 'Change Status',
      VIEW: 'View Details',
      DRAFT_POST: 'Draft Post',
      SCHEDULE_DATEL: 'Schedule date',
      change_status: 'Change Status',
      VIEW_CUSTOMER: 'View Customer Details',
      NOTIFY: 'Notify',
      DOWNLOAD: 'Download',
    },
    FOOTER: {
      about: 'About',
      terms_and_conditions: 'Terms of service',
      privacy: 'Privacy Policy',
      cookie_policty: 'Cookie Policy',
      markting: 'Marketing',
    },
    VALIDATION: {
      required: 'This field is required',
      maxLength: 'Maximum field length:',
      minLength: 'Minimum field length:',
      email: 'Not valid',
      min:"Min is reqired: ",
      max:"Max is required: "
    },
    SIDE_MENU: {
      dashboard: 'Dashboard',
      statistics: 'Statistics',
      pending_reservation: 'Pending Reservation',
      today_reservation: "Today's Reservation",
      reservations: 'Reservations',
      all_reservations: 'All Reservations',
      users_reviews: 'Users Reviews',
      services: 'Services',
      gallery: 'Gallery',
      banners: 'Banners',
      posts: 'Posts',
      create_new_post: 'Create New Post',
      manage_posts: 'Manage Posts',
      manage_comments: 'Manage Comments',
      loyalty: 'Loyalty System',
      offers: 'Offers & Packages',
      new_offer: 'Add new Offer/Package',
      manage_offers: 'Manage Offers',
      admins: 'Admins',
      manage_admins: 'Manage Admins',
      manage_roles: 'Manage Roles',
      users: 'Users',
      news_letter: 'Newsletter',
      contact: 'Experss Messages ',
      notifications: 'Notifications',
      invoices:'Invoices',
      manage_working_times: 'Manage Working Times',
    },
    TABLE: {
      search: 'Search',
      search_admins: 'Search Admins',
      show_admins_only: 'Show Admins Only',
      list_of_admins: 'List of Admins',
      actions: 'Actions',
      active: 'Active',
      disabled: 'Disabled',
      per_page: 'Per Page',
      show_page: 'Show',
      list_of_roles: 'List of Roles',
      search_roles: 'Search Roles',
      search_users: 'Search Users',
      show_active_users: 'Show Active Users Only',
      list_of_users: 'List of Users',
      show_users_only: 'Show Active users only',
      search_posts: 'Search Posts',
      search_by_date: 'Search by date',
    },
    ADMIN_TABLE: {
      add_new_admin: 'Add New Admin',
      manage_admins: 'Manage Admins',
      manage_roles: 'Manage Roles',
      COLUMNS: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone Number',
        role: 'Role',
        status: 'Status',
        name_ar: 'Arabic Name',
      },
      disbale_alert: 'DESABLE ALERT',
      alert_message: 'You are about to disable the',
      keep_account: 'Keep the account active',
      disable_account: 'Disable Account',
      new_admin: 'Create New Admin',
      edit_admin: 'Edit Admin',
      name: 'Name',
      email: 'Email',
      phone: 'Phone Number',
      role: 'Role',
      password: 'Password',
      name_placeholder: 'First and last name ...',
      email_placeholder: 'Email Address',
      generate_password: 'Generate Password',
      save_changes: 'Save Changes',
      delete_alert: 'DELETE ALERT',
      delete_message: 'Are you sure about delete ?',
    },
    ROLES_TABLE: {
      add_new_role: 'Add New Role',
      manage_admins: 'Manage Admins',
      manage_roles: 'Manage Roles',
      COLUMNS: {
        role: 'Role',
      },
      create_role: 'Create Role',
      update_role: 'Update Role',
      pick_the_permission: 'Pick the permission',
      search_permission: 'Search Permission',
      role_name: 'Role Name',
      role_name_ar: 'Arabic Role Name',
      create_new_role: 'Create New Role',
      search: 'Search',
      select_one_of_premade_roles: 'Selece One of Premade roles',
    },
    USERS_TABLE: {
      manage_users: 'Manage Users',
      COLUMNS: {
        user_id: 'User ID',
        name: 'Name',
        gender: 'Gender',
        phone: 'Phone Number',
        email: 'Email',
      },
    },
    POSTS_TABLE: {
      manage_posts: 'Manage Posts',
      list_of_posts: 'List Of Posts',
      search_posts: 'Search Posts',
      add_new_post: 'Create New post',
      publish_post: 'Publish Post',
      Schedule_post: 'Schedule Post',
      draft_post: 'Draft Post',
      update_post: 'Update Post',
      search_by_date: 'Search By Date',
      COLUMNS: {
        post_title: 'Post Title',
        post_content: 'Post Content',
        created_by: 'Created by',
        status: 'Status',
      },
      post_title: 'Post Title',
      post_text: 'Post Text',
      upload_media: 'Upload Media',
      schedule_post:"Schedule Post",
      post_date:'Post Date'
    },
    BANNERS_TABLE: {
      banner: 'Banner',
      manage_banner: 'Manage Banner',
      COLUMNS: {
        status: 'Status',
        banner_title: 'Banner Title',
      },
      show_active: 'Show Active Banner Only',
      search_banner: 'Search Banner',
      list_of_banners: 'List Of Banners',
      disbale_alert: 'DESABLE ALERT',
      alert_message: 'You are about to disable the',
      keep_account: 'Keep the banner active',
      disable_account: 'Disable banner',
      create_banner: 'Create Banner',
      edit_banner: 'Edit Banner',
      delete_alert: 'DELETE ALERT',
      delete_message: 'Are you sure about delete ?',
    },
    GALLERY_TABLE: {
      gallery: 'Gallery',
      manage_gallery: 'Manage Gallery',
      COLUMNS: {
        status: 'Status',
        gallery_title: 'Gallery Title',
        forward_url: 'Forward URL',
      },
      show_active: 'Show Active Gallery Only',
      search_gallery: 'Search Gallery',
      list_of_gallery: 'List Of Gallery',
      disbale_alert: 'DESABLE ALERT',
      alert_message: 'You are about to disable the',
      keep_account: 'Keep the gallery active',
      disable_account: 'Disable Gallery',
      create_gallery: 'Create Gallery',
      edit_gallery: 'Edit Gallery',
      delete_alert: 'DELETE ALERT',
      delete_message: 'Are you sure about delete ?',
    },
    SERVICES_TABLE: {
      services: 'Services',
      manage_services: 'Manage Services',
      COLUMNS: {
        status: 'Status',
        service_name: 'Service Name',
        service_description: 'Service Description',
        service_parent_name: 'Service Parent',
      },
      show_active: 'Show Active Services Only',
      search_service: 'Search Service',
      list_of_service: 'List Of Services',
      disbale_alert: 'DESABLE ALERT',
      alert_message: 'You are about to disable the',
      keep_account: 'Keep the service active',
      disable_account: 'Disable Service',
      create_service: 'Create Service',
      edit_service: 'Edit Service',
      delete_alert: 'DELETE ALERT',
      delete_message: 'Are you sure about delete ?',
      service_name_en: 'Service Name (in English)',
      service_name_ar: 'Service Name (in Arabic)',
      service_desc_en: 'Service Description (in English)',
      service_desc_ar: 'Service Description (in Arabic)',
      make_service_package: 'Make this service a package ?',
      show_service_list: 'Show this service on the list ?',
      service_is_package: 'This service is a package',
      service_is_list: 'This service is Visible to the users',
      select_parent_service: 'Select a parent service',
      add_new_service: 'Add New Service',
    },
    NEWS_LETTER: {
      newsletter: 'Newsletters',
      manage_newsletter: 'Manage Newsletters',
      COLUMNS: {
        email: 'Email',
        phone: 'Phone Number',
      },
      search_newsletter: 'Search Newsletters',
    },
    CONTACT: {
      contact: 'Express Messages',
      manage_contact: 'Manage Express Messages',
      COLUMNS: {
        email: 'Email',
        date: 'Date',
        name: 'Name',
        message: 'Message',
      },
      search_contact: 'Search',
      message_details: 'Message Details',
    },
    RESERVATION_TABLE: {
      reservations: 'Reservations',
      manage_reservation: 'Manage Reservations',
      all_reservation: 'All Reservation',
      COLUMNS: {
        patient_name: "Patient's Name",
        patient_mobile: "Patient's Phone",
        reservation_date: 'Reservation Date',
        service: 'Service',
        status: 'Status',
        diagnostic: 'Diagnostic',
        image_title: 'Image Title',
      },
      search_reservation: 'Search Reservation',
      search_date: 'Search by date',
      search_status: 'Search By status',
      manage_working_times: 'Manage Working Times',
      add_new_reservtion: 'Add New Reservation',
      daily_warp_up: 'Close The Day',
      there_are: 'There Are',
      pending_body: 'Pending Reservation, they will be canceled',
      todays_reservations: "Today's Reservations",
      total_reservations: 'Total Reservations',
      pending_reservations: 'Pending Reservations',
      confirmed_reservations: 'Confirmed Reservations',
      canceled_reservations: 'Canceled Reservations',
      users_reservations: "User's Reservations",
      list_of_images: 'List of Images',
      cancel_pending_and_close: 'Cancel Pending and close the day',
      changeStatus: 'Change Status',
      changeDate: 'Change Date',
      choose_status: 'Choose Status',
      pick_time: 'Pick a date & time',
      select_parent_service: 'Choose a patient',
      select_services: 'Pick Services',
      list_of_Files:"List of Files"
    },
    RESERVATION_DETAILS: {
      reservation_details: 'Reservation Details',
      reservation: 'Reservation',
      reschedule: 'Reschedule Reservation',
      profile_history: 'Show Profile History',
      personal_info: 'Personal Info',
      photo: 'Photo',
      name: 'Name',
      email: 'Email',
      birthday: 'Birthday',
      mobile: 'Phone Number',
      gender: 'Gender',
      city: 'City',
      service_details: 'Service Details',
      services: 'Services',
      status: 'Status',
      reservation_date: 'Reservation Date',
      add_new_service: 'Add New Service',
      metrics_title: 'Health Metrics & Chronic Diseases Form',
      add_metrics: 'Add New Form',
      height: 'Height',
      weight: 'Weight',
      d_history: 'Diseases History',
      prev_procedure: 'Previous procedure',
      save_change: 'Save Changes',
    },
    COMMON: {
      type: 'Type',
    },
    IMAGELIST: {
      create_image: 'Create Image',
      edit_image: 'Edit Image',
      image_title: 'Image Title',
      edit_file:"Edit File",
      file_title:"File Title",
      create_file:"Create File",
    },
    MANAGE_WORKING_TIMES: {
      manage_working_times: 'Manage Working Times',
      shifts: 'Shifts',
      open_at: 'Open at',
      close_at: 'Close at',
      add_working_hour: 'Add new working hour',
      saturday: 'Sat',
      sunday: 'Sun',
      monday: 'Mon',
      tuseday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      no_times_yet: 'No Working Hours yet.',
      exception_working_days: 'Exception working days',
      exception_days_subtitle: 'The days the clinic will be unavailable, and system will not allow appointments to be scheduled on those dates.',
      add_exception_day: 'Add Exception Day',
      no_exception_days_yet: 'No exception days yet.',
    },
    EXCEPTION_WORKING_DAYS_TABLE: {
      title: 'Title',
      date_from: 'Date From',
      date: 'Date',
      date_to: 'Date To',
      off_hours: 'Off Hours',
      time_from: 'Time From',
      time_to: 'Time To',
      is_all_day: 'All Day',
      is_recurring_yearly: 'Recurring Yearly',
      actions: 'Actions',
      search_exception_days: 'Search Exception Days',
      add_new_exception: 'Add New Exception',
      edit_exception: 'Edit Exception',
      delete_exception: 'Delete Exception',
      exception_title: 'Exception Title',
      exception_title_placeholder: 'Enter exception title',
      save_exception: 'Save Exception',
      cancel: 'Cancel',
      validation_errors: {
        future_date: 'Date must be in the future',
        present_date: 'Today\'s date requires specific time validation',
        date_range: 'End date must be the same as or after start date',
        time_range: 'End time must be after start time',
        all_day_today: 'All-day exceptions cannot be set for today',
        time_must_be_future: 'Time must be in the future for today\'s date'
      }
    },
    REVIEWS_TABLE: {
      reviews: 'Reviews',
      manage_reviews: 'Manage Reviews',
      COLUMNS: {
        patient_name: "Patient's Name",
        note: 'Note',
        rating: 'Rating',
        date: 'Date',
      },
      search_review: 'Search Review',
      date_search: 'Search by date',
      filter_rating: 'Filter Rating',
      review_details: 'Review Details',
    },
    USERS_DETAILS:{
      user_details:'User Profile',
      loyalty_points:'Loyalty Points',
      personal_info:'Personal Info',
      edit_loyalty:"Edit the user loyalty point manually",
      increase_loyalty:"Increase loyalty point",
      decrease_loyalty:"Decrease loyalty point",
      exp:'Exp : ',
      reason:"Reason"
    },
    Metrics_TABLE:{
      metrics:' Health Metrics & Chronic Diseases Form History',
      COLUMNS:{
        date:'Date',
        height:'Height',
        weight:'Weight',
        d_history:'Diseases History',
      }
    },
    NOTIFICATIONS_TABLE:{
      notifications:'Notifications',
      notifications_list:"Notifications List",
      search_notifications:'Search Notifications',
      new_notification:'Create New Notification',
      edit_notification:'Edit Notification',
      title_en:"Notification Title (In English)",
      title_ar:"Notification Title (In Arabic)",
      content_en:"Notification Content (In English)",
      content_ar:"Notification Content (In Arabic)",
      isFutureDate:"Is Future Date",
      resend_notify:"Resend Notification",
      resend_notify_message:"You are about to resend this notification to all users?",
      choose_time:"Choose Time",
      COLUMNS:{
        date:"Date",
        title:"Title",
        content:"Content"
      }
    },
    LOYALTY_POINTS_SETTING:{
      loyalty_points_setting:'Manage Loyalty Points',
      details:"Details",
      point_criteria:"Points Ceriteria",
      point_per_riyal:'Points Per Riyal',
      point_per_riyal_message:'Enter the number of loyalty points required to redeem 1 Riyal of discount. For example, if you enter {{points}}, then every {{points}} points will equal 1 Riyal of discount for customers. This value will determine how many points are needed for each Riyal of discount.',
      expire_date:'Expiration date for new points (per days)',
      choose_expire_date:"Choose Expire Date",
      expire_date_message:"Please note, the new expiration policy will only apply to points earned moving forward. Existing points will not be affected by this update. Only new points earned after the change will follow the updated expiration rules.",
      registrationPoints:'Registration Points',
      registrationPoints_message:'Setting {{points}} points will grant the new user a discount of ( {{amount}} ) Riyals',
      reviewPoints:'Review Points',
      reviewPoints_message:'Setting {{points}} points will grant each review a discount of ( {{amount}} ) Riyals',
      referralPoints:'Referral Points',
      sharePointsPercentage_message:'This sets the maximum percentage of points a user can share. Shared points will keep their original expiration date.',
      invoiceRedeemPercentage:'Invoice Redeem Percentage',
      invoiceRedeemPercentage_message:'If you set it to {{percentage}}, for every {{points}} Riyals spent, the customer gets {{amount}} points. This is for new reservations after the change.',
      sharePointsPercentage:'Sharing points limit percentage',
      maxSharePoints:"Maximum shared points",
      maxSahrePoints_message:"This sets the maximum number of points a user can share. Shared points will keep their original expiration date.",
      terms_header:"Loyalty program terms and conditions",
      terms_en:"English text",
      terms_ar:"Arabic text"
    },
    INVOICES_TABLE:{
      invoices:'Invoices',
      manage_invoices:'Manage Invoices',
      COLUMNS:{
        id:'ID',
        date:"Date",
        patient_name:"Patient's Name",
        patient_phone:"Patient's Phone",
        total_price:"Total Price",
        status:"Status",
      },
      all_invoices:"All Invoices",
      search_invoices:"Search Invoices",
      search_by_date:"Search By Date",
      create_new_invoice:"Create New Invoice",
      amount:"Amount",
      invoice_details:"Invoice Details",
      print_invoice:"Print Invoice",
      billed_to:"Billed to",
      invoice_number:"Invoice Number",
      invoice_date:"Invoice Date",
      reservation_id:"Reservation ID",
      invoice_sar:"Invoice of ( SAR )",
      services:"Services",
      sub_total:"Total Before Discount",
      discount:"Discount",
      total:"Total",
      select_reservation: 'Pick Reservation',
      add_discount:'Add Discount',
      currancy:'SAR',
      user_invoices:'User Invoices',
    },
    DASHBOARD:{
      total_visits:"Total",
      total_compeleted_visits:"Total Compeleted",
      total_cancel_visits:"Total Canceled",
      total_opening_visits:"Total Pending",
      yearly:'Yearly',
      daily:'Daily',
      quarterly:'Quarterly',
      monthly:'Monthly',
      chart_reports:'Chart Reports'
    },
    REALTIME_NOTIFICATION:{
      notifications:"Notifications",
      unseen:"Unseen"
    }
  },
};
